module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/1ArANgz/tc-custom/9781617459245.jpg?1703224413244",
      "alt": "This image is the cover for the book Sew Magical"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Sew Magical\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("Create a fairy tale world of unicorns, dragons, mermaids, and more with these paper-piecing projects by the author of "), _c('i', [_vm._v("Cute & Clever Totes")]), _vm._v(".")]), _c('br'), _c('br'), _vm._v("From mystical creatures to a royal princess, a castle, and a brave knight, Mary Hertel’s beloved paper-pieced blocks are simple to sew and easy to love. With sixteen mix-and-match blocks, you’ll unlock the power of imagination in your quilting. Combine the blocks to create seven cute and useful projects ranging from quilts and pillows to a drawstring backpack. With clever patterns and clear instructions, this collection will help paper piecers see that anything is possible.Step-by-step patterns from paper-piecing wizard Mary HertelPiece sixteen blocks of mythic proportions—fairies, a cyclops, a gryphon, and moreShow off the blocks in baby quilts, a wallhanging, or cute pillows for a kids’ bedroom\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Mary Hertel\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Mary Hertel Bio: Mary Hertel is a pattern designer, teacher, and author. She teaches quilting regionally and online. Mary’s work has appeared in a number of magazines and she’s been featured on quilting podcasts and television programs. She lives in Oshkosh, Wisconsin. madebymarney.com")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    C&T Publishing\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0